import { ApiSmpArtGallery } from "@smp/api";
import { Await } from "@smp/utils";
import { useInfiniteQuery } from "react-query";
import { UseInfiniteQueryOptions } from "react-query/types/react/types";

import { useContextApp } from "@/screens/app/context/app";

const KEY = "polotno.folders";

export const useQueryPolotnoFolders = (
  options?: Omit<
    UseInfiniteQueryOptions<
      Await<ReturnType<typeof ApiSmpArtGallery.PolotnoFolder.list>>
    >,
    "queryKey" | "queryFn" | "getNextPageParam"
  >,
) => {
  const {
    state: { organizationId },
  } = useContextApp();

  return useInfiniteQuery<
    Await<ReturnType<typeof ApiSmpArtGallery.PolotnoFolder.list>>
  >(
    [KEY, { organizationId }],
    ({ pageParam }) => ApiSmpArtGallery.PolotnoFolder.list(pageParam),
    {
      getNextPageParam: (response) => response.next || undefined,
      ...(options || {}),
    },
  );
};

useQueryPolotnoFolders.KEY = KEY;
